import { LoadingIcon as LoadingDs, Typography } from "@packages/ds";
import styled from "styled-components";

export const DialogWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 24px 0 16px;
`;

export const NoteText = styled(Typography.BodyText)`
  margin-top: 24px;
`;

export const LoadingSuccess = styled(LoadingDs)`
  display: block;
  margin: 50px 0 0 auto;
`;
